import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_QUESTION } from './types';

export const updateQuestion = createTaskAction(UPDATE_QUESTION);
